import React from 'react';
export const Footer: React.FC = () => {
  return <footer className="bg-black text-gray-400 py-8 md:py-12 border-t border-gray-800" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-159">
        <h4 className="text-white font-serif font-bold text-lg md:text-xl mb-1 md:mb-2" data-id="element-160">
          PROFES DE TELAS RESUELTO™
        </h4>
        <p className="mb-4 md:mb-6 max-w-md mx-auto text-sm md:text-base" data-id="element-161">
          El sistema de clases N°1 para profes de telas en Argentina.
          <br data-id="element-162" />
          <span className="italic text-gray-500 mt-1 block text-xs md:text-base" data-id="element-163">
            Porque enseñar en telas no debería costarte todas las noches de la
            semana.
          </span>
        </p>

        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 md:gap-6 mb-6 md:mb-8 text-xs md:text-sm" data-id="element-164">
          <a href="mailto:contacto@recursosfitness.shop" className="hover:text-white transition-colors" data-id="element-165">
            📧 contacto@recursosfitness.shop
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-166">
            📲 @recursosfitness
          </a>
          <a href="https://recursosfitness.shop" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-id="element-167">
            🌐 recursosfitness.shop
          </a>
        </div>

        <div className="text-[10px] md:text-xs text-gray-600 pt-4 md:pt-8 border-t border-gray-800" data-id="element-168">
          <p data-id="element-169">
            © RecursosFitness™ 2026 — Todos los derechos reservados. Prohibida
            la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
};